import type { AppelApi } from './client.js';
import {
  presentationApi,
  type ChargePresentation,
  type InteretPresentation,
  type RecapitulatifPresentation,
} from './presentation.js';

export interface SourcePresentation {
  readonly horsLigne: boolean;
  charger(galerie: string, id: string, appel: AppelApi): Promise<ChargePresentation>;
  marquerInteret(
    galerie: string,
    id: string,
    oeuvreId: string,
    corps: { exemplaireId?: string | null; interesse: boolean },
    appel: AppelApi,
  ): Promise<{ interet: InteretPresentation }>;
  recapitulatif(galerie: string, id: string, appel: AppelApi): Promise<RecapitulatifPresentation>;
  noter(
    galerie: string,
    id: string,
    corps: { note?: string },
    appel: AppelApi,
  ): Promise<{ contactId: string }>;
}

export const sourcePresentationEnLigne: SourcePresentation = {
  horsLigne: false,
  charger: presentationApi.presenter,
  marquerInteret: presentationApi.marquerInteret,
  recapitulatif: presentationApi.recapitulatif,
  noter: presentationApi.noter,
};
